export default "__VITE_ASSET__CZ$hLvq$__"